import {TargetContainerFormatterInterface} from "./TargetContainerFormatterInterface";

/**
 * 主にEmptyFirstViewのためのnullオブジェクト
 * (型制限に適合するため、空のdiv要素を常時戻す)
 */
export class NullTargetContainerFormatter implements TargetContainerFormatterInterface{
    public format(targets: null): {targetContainer: HTMLElement, targetContainers: HTMLElement[]} {
        // 型アサーションのために、任意のHTMLElementを作成する
        let mockElement = document.createElement("div");
        return {
            targetContainer: mockElement as HTMLElement,
            targetContainers: [] as HTMLElement[]
        }
    }
}